import { PropsWithChildren } from "react";

import "./ShimmeringStub.scss";

export const ShimmeringStub = ({ children }: PropsWithChildren) => (
  <div className="c-shimmering-stub">{children}</div>
);
